import { apiService } from '@/services/APIService';

export default {
  getNotificationStats(params) {
    return apiService.get('/notification/stats', params);
  },

  getNotifications(params) {
    return apiService.get('/notification', params);
  },

  readNotification(id) {
    return apiService.put(`/notification/${id}`);
  },

  readAllNotifications() {
    return apiService.put('/notification/read-all');
  },

  /**
   *  {
   *    notification_ids: number[];
   *  };
   */
  readByIds(payload) {
    return apiService.put('/notification/read-by-id', payload);
  },
};
